.base {
	width: 46px;
	flex-shrink: 0;
	height: 100%;
	background: var(--parrot-chat-surface);
	border-right: 1px solid var(--parrot-chat-border);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2px;
	padding: 7px 0;
}

.logoBtn {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 38px;
	height: 38px;
	margin-bottom: 4px;
	padding: 0;
	background: transparent;
	border: none;
	border-radius: var(--parrot-chat-radius);
	cursor: pointer;
	transition: background 0.12s;
}

.logoBtn:hover {
	background: var(--parrot-chat-menu-hover);
}

.mark {
	width: 36px;
	height: 36px;
	object-fit: contain;
	transition: opacity 0.15s;
}

/* The "open sidebar" panel icon revealed on hover, swapping out the mark. */
.openIcon {
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0;
	color: var(--parrot-chat-text);
	transition: opacity 0.15s;
}

.logoBtn:hover .mark {
	opacity: 0;
}

.logoBtn:hover .openIcon {
	opacity: 1;
}

.openIcon svg {
	width: 20px;
	height: 20px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

.iconBtn {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 0;
	background: transparent;
	border: none;
	border-radius: var(--parrot-chat-radius);
	color: var(--parrot-chat-text-muted);
	cursor: pointer;
	transition: color 0.12s, background 0.12s;
}

.iconBtn:hover {
	color: var(--parrot-chat-text);
	background: var(--parrot-chat-menu-hover);
}

.iconBtn svg {
	width: 18px;
	height: 18px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

.tooltip {
	position: absolute;
	left: calc(100% + 8px);
	top: 50%;
	transform: translateY(-50%);
	padding: 4px 9px;
	background: var(--parrot-chat-surface-raised);
	color: var(--parrot-chat-text);
	border: 1px solid var(--parrot-chat-border-strong);
	border-radius: var(--parrot-chat-radius);
	font-size: var(--parrot-chat-font-size-sm);
	white-space: nowrap;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.12s;
	z-index: 20;
	box-shadow: 0 4px 14px -4px rgba(0, 0, 0, 0.4);
}

.logoBtn:hover .tooltip,
.iconBtn:hover .tooltip {
	opacity: 1;
}
